/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './payment-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-payment-list-page',
  template
})
export class PaymentListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.rep.payments';

  columns: AdminListColumn[] = [
    {param: 'createTime'},
    {param: 'status'},
    {param: 'amount', label: 'budgetAmount'},
    {param: 'billedAmount'},
    {param: 'refundedAmount'},
    {label: 'coupon', param: '', sortable: false},
    {label: 'lineItem', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
